import React from "react"
import { useTranslation } from "react-i18next"

import { TextInput } from "shared/ui/input/text/TextInput"

import { ProjectTitle } from "entities/projects/ui/project-title/ProjectTitle"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export const ProjectFormTitle = React.memo(() => {
  const { t } = useTranslation()
  const { model, isReadonly, isDisabled } = useProjectFormContext()

  return (
    <TextInput.Root
      name="project.title"
      label={t("Project.Project")}
      className="project-form__title"
      readonly={isReadonly}
      disabled={isDisabled}
    >
      <TextInput.Label />
      <TextInput.Focus>
        <TextInput.Input
          placeholder={t("Project.Project")}
          data-testid="project-title-input"
        />
      </TextInput.Focus>
      <TextInput.ErrorMessage />
      <TextInput.Readonly>
        <ProjectTitle
          project={model?.core.data.project?.data}
          showClarificationRequestIndicator
        />
      </TextInput.Readonly>
    </TextInput.Root>
  )
})

ProjectFormTitle.displayName = "ProjectFormTitle"
